export const filterUrls = {
    getNotificationsFilter: '/api/notification-hub/notificationConfig'
};

export const initialState = {
    data: [],
    metadata: {},
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ERROR_NOTIFICATIONS_FILTERS':
            return {
                ...state, isFetching: false, isError: true
            };
        case 'REQUEST_NOTIFICATIONS_FILTERS':
            return {
                ...state, isFetching: true, isError: false
            };
        case 'RECEIVE_NOTIFICATIONS_FILTERS':
            return {
                ...state, isFetching: false, isError: false, data: action?.data?.value
            };
        default:
            return state;
    }
};
